<div class="currency-amount-input" data-testid="currency-amount-input-wrapper">
  <dx-select-box
    data-testid="currency-amount-input-currency-button"
    class="currency-amount-input__currency"
    [items]="currencyOptions"
    [value]="currency"
    valueExpr="code"
    displayExpr="symbol"
    [searchEnabled]="false"
    [showClearButton]="false"
    stylingMode="outlined"
    [disabled]="!isEditable"
    (onValueChanged)="onCurrencySelected($event)">
  </dx-select-box>

  <dx-number-box
    data-testid="currency-amount-input-amount"
    class="currency-amount-input__amount"
    [value]="amount"
    [format]="amountFormat"
    [min]="minAmount"
    [showSpinButtons]="false"
    [placeholder]="config?.placeholder ?? 'Enter amount'"
    [disabled]="!isEditable"
    (onValueChanged)="onAmountChanged($event)">
  </dx-number-box>
</div>